import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
	const { i18n } = useTranslation();

	const toggleLanguage = () => {
		const newLang = i18n.language === 'en' ? 'ar' : 'en';
		i18n.changeLanguage(newLang);
		document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
	};

	return (
		<button
			onClick={toggleLanguage}
			className='bg-blue-100 font-bold text-black px-4 py-2 rounded-full hover:bg-blue-300 transition-all duration-200 '>
			{i18n.language === 'en' ? 'ع' : 'E'}
		</button>
	);
};

export default LanguageSwitcher;
